module.exports = __webpack_public_path__ + "img/icon-google-pay-logo.cc4b5821.svg";